export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const UK_POSTCODE_REGEX = /\b([A-PR-UWYZ]([0-9][0-9A-HJKPSTUW]?|[A-HK-Y][0-9][0-9ABEHMNPRV-Y]?))\s?[0-9][ABD-HJLNP-UW-Z]{2}\b/i;
export function normalisePhoneUK(raw) {
    if (!raw)
        return '';
    let phone = raw.replace(/[^\d+]/g, '');
    if (phone.startsWith('+44'))
        phone = phone.slice(1);
    else if (phone.startsWith('00'))
        phone = phone.slice(2);
    else if (phone.startsWith('0'))
        phone = '44' + phone.slice(1);
    else if (!phone.startsWith('44'))
        phone = '44' + phone;
    return phone;
}
export function validatePhoneUK(raw) {
    if (!raw)
        return false;
    const digits = raw.replace(/\D/g, '');
    if (digits.startsWith('44') && digits.length === 12)
        return true;
    if (digits.length === 11 && (digits.startsWith('07') || digits.startsWith('01') || digits.startsWith('02')))
        return true;
    return false;
}
export function validateEmail(raw) {
    if (!raw)
        return false;
    return EMAIL_REGEX.test(raw.trim());
}
export function validatePostcodeUK(raw) {
    if (!raw)
        return false;
    return UK_POSTCODE_REGEX.test(raw.trim());
}
export function normaliseEmail(raw) {
    if (!raw)
        return '';
    return raw.trim().toLowerCase();
}
export function normaliseName(raw) {
    if (!raw)
        return '';
    return raw.trim().replace(/\s+/g, ' ').toLowerCase();
}
//# sourceMappingURL=validators.js.map